import { render, staticRenderFns } from "./testimonialDisplayComponent.vue?vue&type=template&id=75abde9c&scoped=true&"
import script from "./testimonialDisplayComponent.vue?vue&type=script&lang=js&"
export * from "./testimonialDisplayComponent.vue?vue&type=script&lang=js&"
import style0 from "./testimonialDisplayComponent.vue?vue&type=style&index=0&id=75abde9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75abde9c",
  null
  
)

export default component.exports